import { useId } from 'react';
import { Button, Modal } from '@/shared/components';
import type { TemplatePreview } from '../types/documentTemplates.types';
import { PreviewFrame } from './PreviewFrame';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  isLoading: boolean;
  error: unknown;
  preview: TemplatePreview | null;
}

export function TemplatePreviewModal({ isOpen, onClose, isLoading, error, preview }: Props) {
  const headingId = useId();

  return (
    <Modal isOpen={isOpen} onClose={onClose} ariaLabelledBy={headingId} className="max-w-4xl p-6">
      <h2 id={headingId} className="mb-1 text-lg font-semibold">
        Template preview
      </h2>
      <p className="mb-3 text-sm text-mp-muted">Rendered with sample data. Nothing here is saved or sent.</p>

      <PreviewFrame isLoading={isLoading} error={error} preview={preview} />

      <div className="mt-4 flex justify-end">
        <Button type="button" variant="clear" onClick={onClose}>
          Close
        </Button>
      </div>
    </Modal>
  );
}
